import React, { useEffect, useState } from "react";
import { api } from "../../app/Api/ApiSlice";
import { toast } from "react-toastify";
import UserImage from "../../assets/user.png";
import { useLocation, useParams } from "react-router-dom";
import moment from "moment";
import { useCartSelector } from "../../pages/cartSelectorContext";

const ProductDetails = () => {
  const location = useLocation();
  const { product } = location.state || {};
  const { name } = useParams();
  const { openCartSelector } = useCartSelector();

  const [focusedImg, setFocusedImg] = useState(product?.files?.[0]?.url ?? null);
  const [liked, setLiked] = useState(false);
  const [likesCount, setLikesCount] = useState(product?.likes ?? 0);
  const [comments, setComments] = useState([]);
  const [loadingComments, setLoadingComments] = useState(false);
  const [postingComment, setPostingComment] = useState(false);
  const [commentText, setCommentText] = useState("");
  const [quantity, setQuantity] = useState(1);
  const [cartLoading, setCartLoading] = useState(false);

  const handleLike = async () => {
    try {
      setLiked(prev => !prev);
      setLikesCount(prev => liked ? prev - 1 : prev + 1);
      // optional: await apiJson.post(`/${name}/products/${product._id}/like`);
    } catch (err) {
      console.error(err);
      toast.error("Failed to update like.");
    }
  };

  const fetchComments = async () => {
    if (!product?._id) return;
    try {
      setLoadingComments(true);
      const res = await api.get(`/${name}/products/${product._id}/comments`);
      setComments(res.data ?? []);
    } catch (err) {
      // toast.error(err?.response?.data?.message || "Failed to load reviews.");
    } finally {
      setLoadingComments(false);
    }
  };

  const handleComment = async () => {
    if (!commentText.trim()) return;
    try {
      setPostingComment(true);
      // optional: const res = await api.post(...)
      setComments(prev => [
        ...prev,
        {
          text: commentText,
          createdAt: new Date().toISOString(),
          user: { name: "You" }
        }
      ]);
      setCommentText("");
    } catch (err) {
      toast.error("Failed to post review.");
    } finally {
      setPostingComment(false);
    }
  };

  const handleAddToCart = async () => {
    try {
      setCartLoading(true);
      await openCartSelector(product._id, quantity, name);
    } catch {
      toast.error("Failed to add to cart.");
    } finally {
      setCartLoading(false);
    }
  };

  useEffect(() => {
    fetchComments();
  }, []);

  if (!product) {
    return <div className="product-fallback">Product not found.</div>;
  }

  return (
    <div className="product-page-container">
      <div className="store-banner">
        <h2>{name}</h2>
      </div>

      <div className="product-body">
        <div className="product-media-block">
          {focusedImg && (
            <img className="product-main-img" src={focusedImg} alt={product.title} />
          )}

          <div className="product-thumb-row">
            {product.files?.map((img, i) => (
              <img
                key={i}
                src={img.url}
                alt=""
                className={`product-thumb ${img.url === focusedImg ? "active-thumb" : ""}`}
                onClick={() => setFocusedImg(img.url)}
              />
            ))}
          </div>
        </div>

        <div className="product-info-block">
          <h1 className="product-title">{product.title}</h1>
          <p className="product-price">${Number(product.price).toFixed(2)}</p>
          <p className="product-desc">{product.description}</p>

          <div className="product-like-row">
            <button onClick={handleLike} className="like-btn">
              {liked ? "Unlike" : "Like"} ({likesCount})
            </button>
          </div>

          <div className="product-qty-row">
            <button onClick={() => setQuantity(Math.max(1, quantity - 1))}>-</button>
            <input value={quantity} readOnly />
            <button onClick={() => setQuantity(quantity + 1)}>+</button>
          </div>

          <div className="product-cta">
            <button disabled={cartLoading} onClick={handleAddToCart}>
              {cartLoading ? "Adding..." : "Add to Cart"}
            </button>
          </div>
        </div>
      </div>

      <div className="product-comments-block">
        <h3>Reviews</h3>

        <div className="comment-input-row">
          <input
            placeholder="Write a comment..."
            value={commentText}
            onChange={(e) => setCommentText(e.target.value)}
          />
          <button disabled={postingComment} onClick={handleComment}>
            {postingComment ? "Posting..." : "Post"}
          </button>
        </div>

        {loadingComments ? (
          <p>Loading comments...</p>
        ) : (
          <ul className="comment-list">
            {comments.map((c, i) => (
              <li key={i} className="comment-item">
                <img src={UserImage} alt="user" className="comment-avatar" />
                <div className="comment-body">
                  <strong>{c.user?.name ?? "Unknown"}</strong>
                  <p>{c.text}</p>
                  <small>{moment(c.createdAt).fromNow()}</small>
                </div>
              </li>
            ))}
          </ul>
        )}
      </div>
    </div>
  );
};

export default ProductDetails;
